const styles = theme => ({
  tabsContainer: {
    marginBottom: 16,
  },
  tab: {
    minWidth: 112,
    maxWidth: 'none',
    flex: '1 0 auto',
  },
  tabLabelContainer: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16,
    boxShadow: 'none',
  }),
  button: {
    marginTop: 30,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles
